import { ActionsCard } from "./kinds/Actions";
import { AreaCard } from "./kinds/Area";
import { BarsCard } from "./kinds/Bars";
import { DonutCard } from "./kinds/Donut";
import { GaugeCard } from "./kinds/Gauge";
import { KpiCard } from "./kinds/Kpi";
import { LineCard } from "./kinds/Line";
import { MarkdownCard } from "./kinds/Markdown";
import { ScatterCard } from "./kinds/Scatter";
import { TableCard } from "./kinds/Table";
import type { Widget, WidgetKind } from "./kinds/types";

export type WidgetRenderer = (props: { widget: Widget }) => JSX.Element;

export const WIDGET_REGISTRY: Record<WidgetKind, WidgetRenderer> = {
  bars: BarsCard,
  hbars: BarsCard,
  area: AreaCard,
  sparkline: AreaCard,
  line: LineCard,
  scatter: ScatterCard,
  gauge: GaugeCard,
  donut: DonutCard,
  kpi: KpiCard,
  table: TableCard,
  markdown: MarkdownCard,
  actions: ActionsCard,
};

export type { Widget, WidgetKind };
